import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CardComponent } from './card.component'
import { CardFieldComponent } from './content/fields/field/card-field.component'
import { CardUpdateComponent } from './update/card-update.component'
import { CardTitleComponent } from './title/card-title.component'
import { CardMainFieldsComponent } from './content/main-fields/card-main-fields.component'
import { CardSubtitleComponent } from './content/subtitle/card-subtitle.component'
import { CardStatusRowComponent } from './content/status-row/card-status-row.component'
import { CardHeaderComponent } from './header/card-header.component'
import { CardFieldsComponent } from './content/fields/card-fields.component'
import { CardContentComponent } from './content/card-content.component'
import { MatIconModule } from '@angular/material/icon'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatExpansionModule } from '@angular/material/expansion'
import { CellTypesModule } from '../cell-types/cell-types.module'
import { MatInputModule } from '@angular/material/input'
import { CardDescriptionComponent } from './content/description/card-description.component'
import { TranslocoModule } from '@ngneat/transloco'
import { CommonAppModule } from '../../common/common.module'
import { CardLinkReferencesComponent } from './content/card-link-references/card-link-references.component'

@NgModule({
    declarations: [
        CardComponent,
        CardFieldComponent,
        CardUpdateComponent,
        CardTitleComponent,
        CardMainFieldsComponent,
        CardSubtitleComponent,
        CardStatusRowComponent,
        CardHeaderComponent,
        CardFieldsComponent,
        CardContentComponent,
        CardLinkReferencesComponent,
        CardDescriptionComponent,
    ],
    imports: [
        CommonModule,
        MatIconModule,
        MatFormFieldModule,
        MatExpansionModule,
        CellTypesModule,
        MatInputModule,
        CommonAppModule,
        TranslocoModule,
    ],
    exports: [CardComponent],
})
export class CardModule {}
